import * as TPARuntime from './aspects/tpaPostMessageAspect/tpaPostMessageAspect'
import * as TPAWidgetNativeRuntime from './tpaWidgetNative/runtime'

export {
    TPARuntime,
    TPAWidgetNativeRuntime
}
